import { useQuery } from '@hooks/reactQuery';

import { getConfigurationComparisonReleaseVersions } from '@api/configurationComparison';

import { extractQueryParams } from '@utils/common';
import { fieldsOptionsFormatted } from '@utils/formatter';

import { TCMVersionsDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EVendorsValues } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CC_RELEASE_VERSIONS } from '@constants/queryKeys';

export const useQueryConfigurationComparisonReleaseVersions = (
	props?: TCMVersionsDTO,
): {
	releaseVersionsOptions: TSelectOption<string>[];
	isLoadingReleaseVersionsOptions: boolean;
} => {
	const { vendor, nodes } = props || {};

	const {
		data: releaseVersionsOptions,
		isFetching: isFetchingReleaseVersionsOptions,
		isLoading: isLoadingReleaseVersionsOptions,
	} = useQuery<Array<string>, TSelectOption<string>[]>({
		queryKey: [CC_RELEASE_VERSIONS, props],
		queryFn: extractQueryParams(getConfigurationComparisonReleaseVersions),
		select: (options: Array<string>) => {
			return fieldsOptionsFormatted(options);
		},
		enabled: [!!vendor, vendor === EVendorsValues.mavenir, !!nodes?.length],
		...refetchOptions,
	});

	return {
		releaseVersionsOptions: releaseVersionsOptions || [],
		isLoadingReleaseVersionsOptions: isLoadingReleaseVersionsOptions && isFetchingReleaseVersionsOptions,
	};
};

